import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { darkBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Corrupted / Shadowblight — a menacing dark-magic waste: a void sky, drifting corruption wisps,
 *  sickly violet light-shafts, pooling void-glow, a churning energy bed, rising blight-spores, a
 *  pulsing floor flicker, jagged spires, heavy corruption fog, and a deep violet grade. Distinct
 *  from the ETHEREAL Nexus violet — this is darker, more saturated, dread-laden. */
export const CORRUPTED = darkBiome({
  id: 'corrupted',
  sky: { from: 0x0a0414, to: 0x2e0f3e },
  motes: { colors: [P.witherMagenta, P.blightGlow, P.corruptViolet], count: 26, sizeMin: 5, sizeMax: 15, driftPx: 40 },
  rays: { color: P.corruptViolet },
  glow: {
    blobs: [
      { color: P.corruptViolet, atX: 0.5, atY: 0.96, size: 560, alpha: 0.16 },
      { color: P.witherMagenta, atX: 0.5, atY: 0.1, size: 400, alpha: 0.07 },
    ],
    breathe: { periodMs: 4800, min: 0.65, max: 1.4 },
  },
  lightField: { palette: [P.corruptViolet, P.witherMagenta, P.blightGlow] },
  extraAtmosphereLayers: [
    // Swirling corruption vortex — magenta→violet particles spiralling outward
    // from the scene centre on an expanding spiral (the dark-magic energy churning).
    // Saturated colours + alphaEnd 0.5 so the vortex reads over the dark void sky.
    { kind: 'weather', mode: 'swirl', color: P.witherMagenta, colorEnd: P.corruptViolet,
      size: 12, frequencyMs: 160, lifespanMs: 5000, alphaEnd: 0.5,
      swirlRadiusMin: 50, swirlRadiusMax: 340, swirlTurns: 1.5,
      modulators: [{ target: 'density', shape: 'sine', periodMs: 7000, min: 0.45, max: 1.55, phase: 0.2 }] },
  ],
  weather: { mode: 'rise', color: P.witherMagenta, colorEnd: 0x3a1456,
    gust: { periodMs: 6500, min: 0.5, max: 1.6, phase: 0.2 } },
  flicker: { color: P.witherMagenta },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.corrupted.far, shape: 'spires', color: 0x1d0b30, speed: 0.05, height: 420, alpha: 0.75, detail: 0.9, sway: { ampPx: 10, periodMs: 24000 } },
    { svg: OTHERWORLD_BACKDROPS.corrupted.mid, shape: 'spires', color: 0x140820, speed: 0.11, height: 300, alpha: 0.86, detail: 1.2 },
    { svg: OTHERWORLD_BACKDROPS.corrupted.near, shape: 'spires', color: 0x0c0416, speed: 0.20, height: 190, alpha: 0.95, detail: 1 },
  ],
  fog: { color: P.corruptViolet, bands: 5, alphaMin: 0.04, alphaMax: 0.12, driftPx: 50, periodMinMs: 9000, periodMaxMs: 16000 },
  closer: {
    vignette: { color: 0x0a0414, edgeAlpha: 0.4, washColor: 0x7d2ae8, washAlpha: 0.07 },
    grade: { top: 0x9d4dff, bottom: 0x1a0a2e, strength: 0.14, blend: 'normal' },
  },
});
